import { Component } from '@angular/core';

@Component({
    selector: 'pa-dropdown-separator',
    template: '<li class="pa-dropdown-separator" role="separator"></li>',
    styleUrls: ['./_dropdowns.scss'],
})
export class DropdownSeparatorComponent {}
